import cellarWineListComponent from "@/components/cellarwine/CellarWineListComponent.vue";
export default {
  name: "userCellar",
  data: function data() {
    return {
      searchCriterias: {
        name: "",
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        }
      }
    };
  },
  created: function created() {},
  components: {
    "cellar-wine-list": cellarWineListComponent
  },
  props: ["loggedUserData"]
};